import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminPrivateRoute = ({}) => {
  const uType = useSelector((state) => state.uType);
  return uType === "admin" ? <Outlet /> : <Navigate to="/Admin/Login" />;
};

export default AdminPrivateRoute;
